import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  AppBar,
  Toolbar,
  Typography,
  TextField,
  Button,
  Alert,
  Box,
} from "@mui/material";
import Atras from "./atras";
import { auth } from "../firebase";
import {
  EmailAuthProvider,
  reauthenticateWithCredential,
  updatePassword,
} from "firebase/auth";

const ChangePassword = () => {
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError(null);

    if (newPassword.length < 6) {
      setError("La nueva contraseña debe tener al menos 6 caracteres.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Las contraseñas nuevas no coinciden.");
      return;
    }

    const user = auth.currentUser;
    if (!user) {
      navigate("/login");
      return;
    }

    setLoading(true);
    try {
      const credential = EmailAuthProvider.credential(user.email, currentPassword);
      await reauthenticateWithCredential(user, credential);
      await updatePassword(user, newPassword);
      setSuccess(true);
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      console.error("Error changing password:", err);
      if (err.code === "auth/wrong-password" || err.code === "auth/invalid-credential") {
        setError("La contraseña actual es incorrecta.");
      } else {
        setError("Ocurrió un error al cambiar la contraseña. Intentá de nuevo.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <AppBar position="fixed">
        <Toolbar sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Atras />
          <Typography variant="h6" color="text.primary">
            Cambiar contraseña
          </Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="xs" sx={{ mt: 15, mb: 14 }}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            Contraseña actualizada correctamente.
          </Alert>
        )}
        <TextField
          label="Contraseña actual"
          type="password"
          fullWidth
          margin="normal"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
        />
        <TextField
          label="Nueva contraseña"
          type="password"
          fullWidth
          margin="normal"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <TextField
          label="Repetir nueva contraseña"
          type="password"
          fullWidth
          margin="normal"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        <Box sx={{ mt: 2 }}>
          <Button
            variant="contained"
            fullWidth
            disabled={loading || !currentPassword || !newPassword || !confirmPassword}
            onClick={handleSubmit}
          >
            Guardar nueva contraseña
          </Button>
        </Box>
      </Container>
    </Container>
  );
};

export default ChangePassword;
